export class FloatTranslator {
  from(bean: string): number {
    if (bean === "") {
      return null;
    }
    const parsed = parseFloat(bean);
    return isNaN(parsed)
      ? null
      : parsed;
  }
  to(object: number): string {
    // isNaN()はnullが入るとfalse、undefinedが入るとtrueを返す。そのため別途nullチェックを行っている。
    return (object !== null && !isNaN(object))
      ? object.toString()
      : undefined;
  }
}
